import React from 'react'
import TransactionForm from './TransactionForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import NoDeleteButtonToolbar from 'ui-shared/CustomToolbars/NoDeleteButtonToolbar'
import { Edit } from 'react-admin'

const TransactionEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit actions={<></>}>
        <TransactionForm toolbar={<NoDeleteButtonToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default TransactionEdit
